import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getIncomOfChannleList, deleIncomOfChannle } from "@/api/dataAll/incomeOfChannle";
import addincomChannle from "./components/addIncomChannle";
export default {
  name: "incomeOfChannle",
  components: {
    addincomChannle: addincomChannle
  },
  data: function data() {
    return {
      tableTitle: [],
      obj: {},
      objs: {},
      gameId: "",
      value1: "",
      value2: [],
      total: 0,
      pagrSize: 10,
      addWayConfig: false,
      showing: false,
      tableData: [],
      searchData: {
        page: 1
      }
    };
  },
  created: function created() {
    this.searchClick();
  },
  methods: {
    searchClick: function searchClick() {
      var _this = this;

      getIncomOfChannleList(this.searchData).then(function (res) {
        _this.tableData = res.data.data || [];
        _this.total = res.data.total || 0;
      });
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    changeObj: function changeObj(val) {
      this.obj = val;
    },
    handleSource: function handleSource(id, num) {
      var _this2 = this;

      this.addWayConfig = true;
      this.$nextTick(function () {
        _this2.showing = true;

        _this2.$refs.addWayConfig.init(id, num);
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.searchClick();
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deleIncomOfChannle({
                  id: id
                }).then(function (res) {
                  _this3.searchClick();
                });

                _this3.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};